var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-tabs",
    { staticClass: "dashboard-tabs", attrs: { "content-class": "mt-3" } },
    _vm._l(_vm.tabList, function(tab, i) {
      return _c(
        "b-tab",
        { key: i, attrs: { title: tab.Description, lazy: "" } },
        [_c("TabContent", { attrs: { RecordId: tab.RecordId } })],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1bdb0e01", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bdb0e01","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/MainTab.vue
// module id = null
// module chunks = 